// extracted by mini-css-extract-plugin
export var form = "_gc-0";